import { KeyboardEvent, forwardRef, useState } from 'react';
import '../../../styles/Input.css';
import { InputLabelColor, InputProps } from './Input.types';
import QuestionMark from '../QuestionMark/QuestionMark';
import { ReactComponent as VisibilityIcon } from '../../../assets/vectors/visibility.svg';
import { ReactComponent as VisibilityOffIcon } from '../../../assets/vectors/visibility_off.svg';

export default forwardRef<HTMLInputElement, InputProps>(
  ({
    label,
    labelColor = InputLabelColor.Black,
    questionText,
    error,
    required,
    divProps,
    startIcon: StartIcon,
    endIcon: EndIcon,
    onPressEnter,
    isCompany,
    ...props
  },
  ref
) => {
    const [isPasswordVisible, setPasswordVisible] = useState(false);
  
    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter' && onPressEnter) {
        onPressEnter();
      }
    };
  
    return (
      <div className="input" {...divProps}>
        {label && (
          <label
            className="input__label font-bold"
            style={{ color: labelColor === InputLabelColor.White ? 'var(--white)' : 'var(--black)' }}>
            {label} {required && <span style={{ color: 'var(--primary)' }}>*</span>}{' '}
            {questionText && <QuestionMark text={questionText} />}
          </label>
        )}
        <div
          className="input__input-box"
          {...(props.type === 'checkbox' && {
            style: {
              display: 'block',
              border: 0,
            },
          })}>
          {StartIcon && <StartIcon />}
          <input
            ref={ref}
            className={`input__input${isCompany ? ' input__input--company' : ''}`}
            onKeyDown={handleKeyDown}
            {...props}
            {...(props.type === 'number' && {
              defaultValue: 1,
              min: 1,
              max: 3,
            })}
            {...(props.type === 'password' && {
              type: isPasswordVisible ? 'text' : 'password',
            })}
            {...((props.type === 'checkbox' && props.value) && {
              checked: true
            })}
          />
          {props.type === 'password' &&
            (isPasswordVisible ? (
              <VisibilityOffIcon
                className="input__input-password-icon"
                onClick={() => setPasswordVisible(false)}
              />
            ) : (
              <VisibilityIcon
                className="input__input-password-icon"
                onClick={() => setPasswordVisible(true)}
              />
            ))}
          {EndIcon && <EndIcon />}
        </div>
        <span className="input__error">{error}</span>
      </div>
    );
  }
);
